export default getRolesDefinition;

function getRolesDefinition(user) {
    return {
        'AUTHORIZED': /* @ngInject */ () => {
            return user ? Promise.resolve() : Promise.reject();
        },
        'ADMIN': /* @ngInject */ () => {
            if (!user) {
                return Promise.reject();
            }
            // TODO move to LoginService
            let isAdmin = !!user.roles.find(r => {
                return r.name === 'admin';
            });
            return isAdmin ? Promise.resolve() : Promise.reject();
        },
        'VOUCHERS': /* @ngInject */ () => {
            if (!user) {
                return Promise.reject();
            }
            // TODO move to LoginService
            let hasVouchersRole = !!user.roles.find(r => {
                return r.name === 'vouchers';
            });
            let hasAdminRole = !!user.roles.find(r => {
                return r.name === 'admin';
            });
            return hasVouchersRole || hasAdminRole ?
                Promise.resolve() : Promise.reject();
        },
        'OPERATOR': /* @ngInject */ () => {
            if (!user) {
                return Promise.reject();
            }
            let hasOperatorRole = !!user.roles.find(r => {
                return r.name === 'operator';
            });
            let hasAdminRole = !!user.roles.find(r => {
                return r.name === 'admin';
            });
            return hasOperatorRole || hasAdminRole ?
                Promise.resolve() : Promise.reject();
        },
        'VOUCHERCOLLECTOR': /* @ngInject */ () => {
            if (!user) {
                return Promise.reject();
            }
            let hasVCRole = !!user.roles.find(r => {
                return r.name === 'vouchercollector';
            });
            return hasVCRole ? Promise.resolve() : Promise.reject();
        }
    };
}

